import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GetTeamLeadersKey } from '../queries/useGetTeamLeaders';
import { TeamLeader } from '../../api/queries';
import axios from 'axios';

export const addTeamLeaderToTeam = async (
  email: TeamLeader['email'],
  teamId: number,
) => {
  return axios.post(`/api/teams/invite`, { teamId, email });
};

export const useAddTeamLeaderMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (email: TeamLeader['email']) =>
      addTeamLeaderToTeam(email, teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetTeamLeadersKey],
      });
    },
  });
};
